import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nav: '', // 激活的页签
  },
  getters: {},
  mutations: {
    SET_NAV: (state, nav) => {
      localStorage.setItem('SET_NAV', nav)
      state.nav = nav
    },
  },
  actions: {},
  modules: {}
})